
<template>

	<div style="flex: 1;overflow-y: auto;overflow-x: hidden;">

		<setup ref="setup" :cost_evaluation_id="id" :data="data" v-on:edit="edit"/>
		<set_confidence ref="set_confidence" :cost_evaluation_id="id" :data="cost_evaluation_data" v-on:edit="edit" v-on:input="value => { cost_evaluation_data.modeling.attrs_confidences = value }"/>

		<div v-if="objects_initialized" class="h-100">

			<analogues v-if="active_step == 'comparative_step1'" ref="analogues" :id="id" :group_id="group_id" :data="data" v-on:evaluate_model="() => $emit('evaluate_model')" v-on:bring_back="bring_back"/>

			<statistic :class="active_step != 'comparative_step2' && 'd-none'" :id="id" ref="statistic" :group_id="group_id" :data="data" v-on:edit="edit" v-on:evaluate_model="() => $emit('evaluate_model')" v-on:bring_back="bring_back" v-on:set_steps_value="(steps) => $emit('set_steps_value', steps)" :not_editable="not_editable" v-on:make_formula="() => make_formula()"/>
				
			<models v-if="active_step.startsWith('comparative_step3')" ref="models" :id="id" :group_id="group_id" :data="data" :active_model="active_step"/>

			<corrections v-if="active_step.startsWith('comparative_step4')" ref="corrections" :id="id" :group_id="group_id" :not_editable="not_editable" v-on:need_refresh="() => make_formula()" />

			<setup_content v-if="active_step == 'comparative_step5'" :title="!not_editable ? 'Модель определения кадастровой стоимости' : 'Детализация расчета'" class="main-container">
				<setup_frame v-if="!data.fixed" :title="data.type + ' модель'">
					<span v-html="formula"/>
				</setup_frame>
				<span v-else><span v-html="formula"/></span>
				
				<div v-if="(!not_editable || data.fixed)" class="mt-3 d-flex justify-content-center" style="gap: 16px">
					<b-button v-if="check_roles([ 'cost' ])" class="d-flex align-items-center" style="gap: .25rem" variant="primary" v-on:click="calculate">
						<base-icon name="calc"/>Рассчитать кадастровую стоимость
					</b-button>
				</div>

				<details_modeling ref="details" :id="group_id" :cost_evaluation="data" style="flex: 1;" />

			</setup_content>
			
		</div>

		<!-- <b-tabs v-if="objects_initialized" class="blue-500">

			<b-tab title="Объекты-аналоги для построения статистической модели">


			</b-tab>

			<b-tab title="Статистический анализ" active>


			</b-tab>

			<b-tab title="Парный анализ">

				<pair ref="pair" :id="id" :data="data" v-on:bring_back="bring_back"/>

			</b-tab>

			<b-tab title="Анализ статистической модели">


			</b-tab>

			<b-tab title="Анализ невязок">

				<diff ref="diff" :id="id" :data="data" v-on:bring_back="bring_back"/>

			</b-tab>

			<b-tab title="Статистика">

				<correlation :id="id" ref="correlation" :group_id="group_id" :data="data"/>

			</b-tab>

		</b-tabs> -->

	</div>

</template>

<script>

import api from "../../../../../api"
import { bus } from "../../../../../api/bus"
import o from "./objects"
import analogues from "./analogues"
import statistic from "./statistic"
// import pair from "./pair"
import models from "./models"
import corrections from "../corrections"
// import diff from "./diff"
import setup from "./setup"
import set_confidence from "./set_confidence"
// import correlation from "./correlation"
import details_modeling from "./details"
import setup_content from "../setup_assets/content"
import setup_frame from "../setup_assets/frame"

export default
{
	props :
	{
		id : String,
		group_id : String,
		data : Object,
		cost_evaluation_data : Object,
        active_step : String,
		not_editable : Boolean,
	},

	components :
	{
		analogues,
		statistic,
		// pair,
		// diff,
		models,
		setup,
		set_confidence,
		// correlation,
		details_modeling,
        setup_content,
        setup_frame,
		corrections,
	},

	data()
	{
		return {

			service : "cadastral_cost_evaluation",

			objects_initialized : false,
			init_done : false,

			// Стек операций
			operations : [],

			formula : null,
			
		}
	},

	watch :
	{
		id :
		{
			immediate : true,

			handler(id)
			{
				if(id)
				{
					this.id = id

					this.make_formula()
				}
			},
		},

		data :
		{
			immediate : true,
			deep : true,
			
			handler(data)
			{
				return this.init(this.group_id, data)
			},
		},

		group_id :
		{
			immediate : true,

			handler(group_id)
			{
				return this.init(group_id, this.data)
			},
		},
	},

	mounted()
	{
		window.addEventListener("keydown", this.key_down)

		bus.$on("clean_params_finish", () => o.objects().reset_state(false, false))
		bus.$on("modeling:set_state_for_selected", (state) => o.objects().set_state_for_selected(! state))

		this.$emit("evaluate_model")
	},

	beforeDestroy()
	{
		window.removeEventListener("keydown", this.key_down)
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		init(group_id, data)
		{
			if(! this.init_done)
			{
				var promise = o.init(this, group_id, data, operation => this.operations.push(operation), message => api.show_notification(this, message))

				if(promise != null)
				{
					this.init_done = true

					promise.then(
						() =>
						{
							o.objects().bus.$on("evaluate_model", () => this.$emit("evaluate_model"))

							this.objects_initialized = true
						})
				}
			}

			this.make_formula()
		},

		setup()
		{
			this.$refs.setup.execute()
		},

		evaluate_confidence()
		{
			api.call(this, this.service, "evaluate_confidence", { id : this.id },
				response =>
				{
					this.data.attrs_confidences = response.data
					this.$emit("evaluate_model")
				})
		},

		set_confidence()
		{
			this.$refs.set_confidence.execute()
		},

		edit(ev)
		{
			var operation = null

			if(ev.save_operation_in_history)
			{
				operation = { type : "attrs", fields : {}, old_fields : {} }

				Object.entries(ev.fields).forEach(
					desc =>
					{
						const key = desc[0]
						const value = desc[1]

						if(key == "modeling.attrs")
						{
							var old_value = []

							this.data.attrs.forEach(attr => old_value.push(attr.id))
							
							operation.fields[key] = value
							operation.old_fields[key] = old_value
						}
						else if(key.includes("modeling.attrs_references"))
						{
							// TODO
						}
						else if(key.includes("modeling.attrs_confidences"))
						{
							// TODO
						}
					})
			}

			api.call(this, this.service, "edit", { id : this.id, fields : ev.fields },
				() =>
				{
					if(ev.save_operation_in_history)
						this.operations.push(operation)

					// this.$refs.correlation.refresh()
					// this.$refs.statistic.update()

					this.$emit("evaluate_model")
				})
		},

		bring_back()
		{
			if(this.operations.length > 0)
			{
				const operation = this.operations.pop()

				if(operation.type == "set_objs_state")
					o.objects().set_state(operation.obj_ids, operation.old_bad, false)
				else if(operation.type == "attrs")
				{
					if(operation.fields["modeling.attrs"] == null)
					{
						// Была изменена группировка
						// TODO
					}
					else
					{
						// Создан или удален ЦОФ - attrs_references не восстанавливаем
						
						var ids = operation.fields["modeling.attrs"]
						var old_ids = operation.old_fields["modeling.attrs"]

						// Был добавлен ЦОФ - его нужно удалить
						if(ids.length > old_ids.length)
							ids.forEach(
								id =>
								{
									if(old_ids.find(old_id => old_id == id) == null)
										this.$refs.statistic.$refs.variables.delete_attr(id, false)
								})
						// Был удален ЦОФ - его нужно добавить
						else
							old_ids.forEach(
								old_id =>
								{
									if(ids.find(id => old_id == id) == null)
										this.$refs.statistic.$refs.variables.add_attr(old_id, false)
								})
					}
				}
			}
		},

		key_down(ev)
		{			
			if (this.active_step === "comparative_step1" || this.active_step === "comparative_step2")
			{
				ev.stopPropagation()

				if(ev.code == "KeyZ" && ev.ctrlKey)
					this.bring_back()
				else if(ev.code == "Escape")
					bus.$emit("reset_lasso")
				else if(ev.code == "Space" && (ev.ctrlKey || ev.shiftKey))
				{
					o.objects().set_state_for_selected(! ev.ctrlKey)
				}
			}
		},

		make_formula()
		{
			api.call(this, "cadastral_corrections", "get_many", { query : { "cost_evaluation" : this.id } },
				response =>
				{
					const corrections = api.sort_objects_array_by_key(response.data, "order")
					var formula = this.data.printable_formula.exp
					var prev_add = false

					if(this.data.type == "Линейная")
					{
						formula = this.data.printable_formula.add
						prev_add = true
					}
					else if(this.data.type == "Мультипликативная степенная")
					{
						formula = this.data.printable_formula.mult
						prev_add = true
					}

					corrections.forEach(
						cor =>
						{
							var value = cor.value

							if(! cor.apply)
								value = "<span style='color: red'>" + value + "</span>"

							if(cor.type == "Мультипликативная")
							{
								if(prev_add)
								{
									formula = "( " + formula + " ) * " + value
									prev_add = false
								}
								else
									formula = formula + " * " + value
							}
							else
							{
								formula = formula + " + " + value
								prev_add = true
							}
						})

					this.formula = formula
				})
		},

		calculate()
		{
			api.call_long_operation(this, "Группа / Множественное редактирование / Расчеты / Расчет кадастровой стоимости", "cadastral_groups", "set_cost",
				{ id : this.group_id, calculation_types : [ "Сравнительный подход" ], evaluate_result_cost : !!this.data.model_imported },
				response =>
				{
					api.open_response_url(response)

					this.make_formula()
					this.$refs.details.refresh()
				},
				{ success_msg : "Расчет КС завершен" }
			)
		},
	}
}

</script>
